<template>
  <vue-final-modal
      v-model="showModal"
      @click-outside="modalClose"
      classes="modal-container"
      @click-button="modalClose"
      content-class="modal-content">
    <div class="container-fluid">
      <div class=" d-flex gap-2">
        <img src="@/assets/img/coin.png" alt="wallet-coin" width="20" height="20">
        <p class="title">কয়েনের ব্যবহার </p>

      </div>
      <hr>
      <div>
        <ol>
          <li>আপনার বন্ধুকে চ্যালেঞ্জে করতে হলে কমপক্ষে বাজির পরিমান কয়েন থাকতে হবে </li>
          <li> জেনালের কুইজ ও চ্যালেঞ্জ উভয় ক্ষেত্রেই  পুনরায় প্রশ্নের উত্তর দেয়ার চেষ্টা করতে আপনি আপনার কয়েন ব্যবহার করতে পারবেন </li>
          <li> টুর্নামেন্ট খেলার সময় আপনি কয়েন ব্যয় করে লাইফলাইন ব্যবহার করতে পারবেন </li>
        </ol>
      </div>
      <div class="d-flex gap-2">
        <img src="@/assets/img/diamonds.png" alt="wallet-gems" width="20" height="20">
        <p class="title"> জেম এর ব্যবহার </p>

      </div>
      <hr>
      <div>
        <ol>
          <li>টুর্নামেন্ট খেলার অসময় আপনি জেমস ব্যবহার করে যেকোনো প্রশ্নের উত্তর করতে পারবেন </li>
        </ol>
      </div>
      <button> ওকে </button>

    </div>
  </vue-final-modal>
</template>

<script>
import {VueFinalModal} from 'vue-final-modal';

export default {
  name: "CoinModal",
  props: ['modalShow'],
  components: {
    VueFinalModal,
  },
  data() {
    return {
      showModal: this.modalShow,
    }
  },
  methods: {
    modalClose() {
      this.emitter.emit('coin-modal-close-event', {'eventContent': false})
    }
  }
}
</script>

<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
}

.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.title {
  font-size: 22px;
  color:black;
  font-weight: bold;
}
button {
  height:40px;
  width:100%;
  background-color: #FF2E75 ;
  border-radius: 8px;
  border:1px solid #FF2E75;
  color: #FFFFFF;
  font-size: 20px;
  font-weight:bold;
}
img {
  margin-top: 10px;
}
</style>
